/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `*:focus {
  outline: none;
}

/* default */
:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  height: calc(46rem/14);
  width: 100%;
  max-width: calc(576rem/14);
  font-size: calc(14rem/14);
}
:host .container {
  height: 100%;
  text-decoration: none;
  background-color: #F0F3F4;
  background-color: var(--davinci-color-lightgray-1, #F0F3F4);
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
}
:host .container .slotPlaceholder {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
          flex-direction: column;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  -webkit-box-flex: 0;
          flex: 0 1 auto;
}
:host .container .slotPlaceholder ::slotted(img) {
  height: calc(46rem/14);
  width: auto;
  min-width: calc(46rem/14);
}
:host .container .content {
  -webkit-box-flex: 1;
          flex: 1 1 auto;
  padding: 0 calc(20rem/14);
}
:host .container .content .title {
  height: calc(22rem/14);
  line-height: calc(22rem/14);
  font-weight: bold;
  color: #505F6B;
  color: var(--davinci-color-secondary-light, #505F6B);
}
:host .container .content .description {
  height: calc(12rem/14);
  font-size: calc(12rem/14);
  line-height: calc(12rem/14);
  color: #323C43;
  color: var(--davinci-color-text-on-background, #323C43);
}
:host .container .actionIcon {
  -webkit-box-flex: 0;
          flex: 0 0 auto;
  min-width: calc(24rem/14);
  padding: 0 1rem;
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .container .actionIcon davinci-icon,
:host .container .actionIcon davinci-icon-ref {
  font-size: 1rem;
}
:host .container:hover, :host .container:active {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-primary-light, #e5f1f8);
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .container {
  background-color: #F9FAFB;
  background-color: var(--davinci-color-lightgray-2, #F9FAFB);
}
:host([disabled]) .container .slotPlaceholder ::slotted(img) {
  opacity: 0.5;
}
:host([disabled]) .container .content .title, :host([disabled]) .container .content .description {
  color: #8999A4;
  color: var(--davinci-color-text-on-background-disabled, #8999A4);
}
:host([disabled]) .container .actionIcon {
  fill: #8999A4;
  fill: var(--davinci-color-text-on-background-disabled, #8999A4);
}`;
export { style };
//# sourceMappingURL=Tile.style.js.map